 <div id="nchat" chat-sdk="___$_1"></div>

 <script>
   // NEXUS
   (function (d, id) {
     var js = d.createElement('script');
     js.src = 'https://geia.cloudnexcore.com.br:3002/nchatsdk.js';
     //  js.src = "https://nexcore.geia.com.br:3002/nchatsdk.js";
     (d.head || d.getElementsByTagName('head')[0]).appendChild(js);
   }(document, 'chat-sdk'));
   // NEXUS
 </script>